module.exports = __webpack_public_path__ + "img/9f7ff5c.png";